import { render } from "./AboutComponent.vue?vue&type=template&id=ef167340"
import script from "./AboutComponent.vue?vue&type=script&lang=js"
export * from "./AboutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__